import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-warn",
  "use": "icon-warn-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-warn\">\n<path d=\"M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z\" fill=\"#FFCF00\" />\n<path d=\"M10.7188 12.1641H9.28125L9.05469 4.0625H10.9375L10.7188 12.1641ZM11.0312 15H8.96094V13.1172H11.0312V15Z\" fill=\"black\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol